// import Player from '@vimeo/player';

// class VideoComponent {

//     /**
//      * @type {HTMLElement}
//      */
//     element;

//     /**
//      * @type {HTMLElement}
//      */
//     videoElement;

//     /**
//      * @type {Player}
//      */
//     player;

//     /**
//      * @type {Player.Options}
//      */
//     options = {
//         background: false,
//         responsive: true,
//         loop: false,
//         muted: false,
//         autoplay: false,
//         controls: false,
//         playsinline: false,
//     };

//     _isPaused;

//     get isPaused() {
//         return this._isPaused;
//     }

//     set isPaused(value) {
//         this._isPaused = !!value;
//         this.onStateChange();
//     }

//     constructor(element) {
//         this.element = element;

//         if (!element) {
//             return;
//         }

//         this.videoElement = this.element.querySelector('[data-video-element]');

//         if (!this.videoElement) {
//             return;
//         }

//         this.init();
//     }

//     init() {
//         this.parseOptions();
//         this.createPlayer();
//         this.addListeners();
//     }

//     parseOptions() {
//         const scriptEl = this.element.querySelector('[data-video-json] script');

//         if (!scriptEl) {
//             return;
//         }

//         try {
//             const json = JSON.parse(scriptEl.textContent);
//             Object.assign(this.options, json);
//             scriptEl.remove();

//             this.playOnHover = this.options.play_on_hover ?? false;
//         } catch(error) {
//             console.warn('Invalid json data');
//         }
//     }

//     createPlayer() {
//         this.player = new Player(this.videoElement, this.options);
//     }

//     addListeners() {
//         if (!this.options.play_button) {
//             return;
//         } else {
//             this.videoElement.style.pointerEvents = 'none';
//         }

//         this.player.on('loaded', () => {
            
//             if (this.options.autoplay || this.options.background) {
//                 this.isPaused = false;
//             } else {
//                 this.player.getPaused().then(isPaused => {
//                     this.isPaused = isPaused;
//                 });
//             }

//             this.element.addEventListener('click', () => {
              
//                 this.player.getPaused().then(isPaused => {
//                     if (isPaused) {
//                         this.player.play();
//                         this.isPaused = false;
//                     } else {
//                         this.player.pause();
//                         this.isPaused = true;
//                     }
//                 });
//             });
//         });
//     }
    
//     onStateChange() {
//         if (this.isPaused) {
//             this.element.classList.add('block-vimeo--paused');
//         } else {
//             this.element.classList.remove('block-vimeo--paused');
//         }
//     }
// };

// const initVideos = () => {
//     Array.from(document.querySelectorAll('.block-vimeo')).forEach((video) => {
//         new VideoComponent(video);
//     });
// };

// initVideos();

// export default initVideos;
